import { gql } from 'apollo-angular';

export const ADMIN_FLEET_LIST = gql`
  query AdminFleetList($page: Int!, $status: FleetAccountStatusEnum) {
    adminFleetList(page: $page, status: $status) {
      fleetId
      fleetCode
      operatorName
      registeredBusinessName
      fleetType
      cpcExpirationDate
      status
      declineRemarks
      dateApproved
      dateCreated
      dateUpdated
      accountHolder {
        fleetAccountId
        firstName
        lastName
        email
        mobile
        role
        isActive
        isAccountHolder
        dateCreated
        dateUpdated
      }
    }
  }
`;

export const ADMIN_FLEET_DETAIL = gql`
  query AdminFleetDetail($fleetId: HashedId!) {
    adminFleetDetail(fleetId: $fleetId) {
      fleetId
      fleetCode
      operatorName
      registeredBusinessName
      representativeFirstName
      representativeLastName
      representativeMobile
      representativeEmail
      ltfrbCpcNumber
      fleetType
      cpcExpirationDate
      allowedActiveVehicles
      documents {
        fleetDocumentId
        documentUrl
        documentType
        status
        remarks
        dateCreated
        dateUpdated
      }
      missingRequirements
      documentApprovalHistory {
        fleetAuditTrailId
        fleetDocumentId
        documentType
        documentUrl
        action
        status
        remarks
        actorType
        adminId
        adminName
        fleetAccountId
        dateCreated
      }
      status
      declineRemarks
      dateApproved
      dateCreated
      dateUpdated
      accountHolder {
        fleetAccountId
        firstName
        lastName
        email
        mobile
        role
        isActive
        isAccountHolder
        dateCreated
        dateUpdated
      }
    }
  }
`;

export const FLEET_AMENDMENT_REQUESTS = gql`
  query FleetAmendmentRequests($fleetId: HashedId!) {
    fleetAmendmentRequests(fleetId: $fleetId) {
      fleetAmendmentRequestId
      fleetId
      fieldName
      message
      adminId
      dateCreated
    }
  }
`;

const FLEET_VEHICLE_REGISTRY_FIELDS = `
  fleetVehicleRegistryId
  fleetId
  fleetAccountId
  plateNumber
  conductionNumber
  vehicleType
  vehicleModel
  yearModel
  vehicleMaker
  vehicleId
  status
  dateCreated
  dateUpdated
`;

export const ADMIN_FLEET_VEHICLE_REGISTRIES = gql`
  query AdminFleetVehicleRegistries($input: FleetVehicleRegistryListInput!) {
    adminFleetVehicleRegistries(fleetVehicleRegistryListInput: $input) {
      items {
        ${FLEET_VEHICLE_REGISTRY_FIELDS}
        hasAssociatedPartner
        associatedPartner {
          partnerId
          firstName
          middleName
          lastName
          membershipId
          mobile
          email
          isOnline
        }
      }
      total
      page
      limit
      totalPages
    }
  }
`;

export const ADMIN_FLEET_MANAGEMENT_LIST = gql`
  query AdminFleetManagementList($input: AdminFleetManagementListInput!) {
    adminFleetManagementList(adminFleetManagementListInput: $input) {
      items {
        fleetId
        fleetCode
        operatorName
        fleetType
        status
        activeVehicleCount
        activeDriverCount
        dateCreated
      }
      total
      page
      limit
      totalPages
    }
  }
`;

export const ADMIN_FLEET_MANAGEMENT_STATS = gql`
  query AdminFleetManagementStats($fleetType: FleetTypeEnum!) {
    adminFleetManagementStats(fleetType: $fleetType) {
      totalFleetOperators
      totalVehicles
      activeDrivers
      totalDrivers
    }
  }
`;
